const apbeeful = [
    {
        "variations": [
            {
                "id": 2927,
                "color": "MUSTARD",
                "size": "M",
                "sku": "UT-1717-MUD-M"
            },
            {
                "id": 2930,
                "color": "MUSTARD",
                "size": "L",
                "sku": "UT-1717-MUD-L"
            },
            {
                "id": 2926,
                "color": "MUSTARD",
                "size": "S",
                "sku": "UT-1717-MUD-S"
            },
            {
                "id": 2932,
                "color": "MUSTARD",
                "size": "2XL",
                "sku": "UT-1717-MUD-2XL"
            },
            {
                "id": 2931,
                "color": "MUSTARD",
                "size": "XL",
                "sku": "UT-1717-MUD-XL"
            },
            {
                "id": 2868,
                "color": "BLACK",
                "size": "S",
                "sku": "UT-1717-BLK-S"
            },
            {
                "id": 2899,
                "color": "NAVY",
                "size": "L",
                "sku": "UT-1717-NAY-L"
            },
            {
                "id": 2873,
                "color": "BLACK",
                "size": "3XL",
                "sku": "UT-1717-BLK-3XL"
            },
            {
                "id": 2896,
                "color": "MOSS",
                "size": "L",
                "sku": "UT-1717-MOS-L"
            },
            {
                "id": 2917,
                "color": "YAM",
                "size": "M",
                "sku": "UT-1717-YAM-M"
            },
            {
                "id": 2648,
                "color": "NAVY",
                "size": "S",
                "sku": "UT-1717-NAY-S"
            },
            {
                "id": 2893,
                "color": "WHITE",
                "size": "2XL",
                "sku": "UT-1717-WHE-2XL"
            },
            {
                "id": 2886,
                "color": "ORCHID",
                "size": "M",
                "sku": "UT-1717-ORD-M"
            },
            {
                "id": 2906,
                "color": "GRAPHITE",
                "size": "S",
                "sku": "UT-1717-GRE-S"
            },
            {
                "id": 2909,
                "color": "GRAPHITE",
                "size": "XL",
                "sku": "UT-1717-GRE-XL"
            },
            {
                "id": 2903,
                "color": "LIGHT GREEN",
                "size": "L",
                "sku": "UT-1717-LIN-L"
            },
            {
                "id": 2881,
                "color": "IVORY",
                "size": "M",
                "sku": "UT-1717-IVY-M"
            },
            {
                "id": 2920,
                "color": "YAM",
                "size": "2XL",
                "sku": "UT-1717-YAM-2XL"
            },
            {
                "id": 2910,
                "color": "GRAPHITE",
                "size": "2XL",
                "sku": "UT-1717-GRE-2XL"
            },
            {
                "id": 2901,
                "color": "LIGHT GREEN",
                "size": "S",
                "sku": "UT-1717-LIN-S"
            },
            {
                "id": 2649,
                "color": "NAVY",
                "size": "M",
                "sku": "UT-1717-NAY-M"
            },
            {
                "id": 2904,
                "color": "LIGHT GREEN",
                "size": "XL",
                "sku": "UT-1717-LIN-XL"
            },
            {
                "id": 2914,
                "color": "BLUE JEAN",
                "size": "XL",
                "sku": "UT-1717-BLN-XL"
            },
            {
                "id": 2882,
                "color": "IVORY",
                "size": "L",
                "sku": "UT-1717-IVY-L"
            },
            {
                "id": 2923,
                "color": "BLOSSOM",
                "size": "L",
                "sku": "UT-1717-BLM-L"
            },
            {
                "id": 2895,
                "color": "MOSS",
                "size": "M",
                "sku": "UT-1717-MOS-M"
            },
            {
                "id": 2912,
                "color": "BLUE JEAN",
                "size": "M",
                "sku": "UT-1717-BLN-M"
            },
            {
                "id": 3007,
                "color": "WHITE",
                "size": "S",
                "sku": "UT-1717-WHE-S"
            },
            {
                "id": 2908,
                "color": "GRAPHITE",
                "size": "L",
                "sku": "UT-1717-GRE-L"
            },
            {
                "id": 2915,
                "color": "BLUE JEAN",
                "size": "2XL",
                "sku": "UT-1717-BLN-2XL"
            },
            {
                "id": 2889,
                "color": "ORCHID",
                "size": "2XL",
                "sku": "UT-1717-ORD-2XL"
            },
            {
                "id": 2924,
                "color": "BLOSSOM",
                "size": "XL",
                "sku": "UT-1717-BLM-XL"
            },
            {
                "id": 2925,
                "color": "BLOSSOM",
                "size": "2XL",
                "sku": "UT-1717-BLM-2XL"
            },
            {
                "id": 2880,
                "color": "IVORY",
                "size": "S",
                "sku": "UT-1717-IVY-S"
            },
            {
                "id": 2650,
                "color": "NAVY",
                "size": "2XL",
                "sku": "UT-1717-NAY-2XL"
            },
            {
                "id": 2919,
                "color": "YAM",
                "size": "XL",
                "sku": "UT-1717-YAM-XL"
            },
            {
                "id": 2911,
                "color": "BLUE JEAN",
                "size": "S",
                "sku": "UT-1717-BLN-S"
            },
            {
                "id": 2890,
                "color": "WHITE",
                "size": "M",
                "sku": "UT-1717-WHE-M"
            },
            {
                "id": 2892,
                "color": "WHITE",
                "size": "XL",
                "sku": "UT-1717-WHE-XL"
            },
            {
                "id": 2900,
                "color": "NAVY",
                "size": "XL",
                "sku": "UT-1717-NAY-XL"
            },
            {
                "id": 2897,
                "color": "MOSS",
                "size": "XL",
                "sku": "UT-1717-MOS-XL"
            },
            {
                "id": 2922,
                "color": "BLOSSOM",
                "size": "M",
                "sku": "UT-1717-BLM-M"
            },
            {
                "id": 2888,
                "color": "ORCHID",
                "size": "XL",
                "sku": "UT-1717-ORD-XL"
            },
            {
                "id": 2921,
                "color": "BLOSSOM",
                "size": "S",
                "sku": "UT-1717-BLM-S"
            },
            {
                "id": 2913,
                "color": "BLUE JEAN",
                "size": "L",
                "sku": "UT-1717-BLN-L"
            },
            {
                "id": 2907,
                "color": "GRAPHITE",
                "size": "M",
                "sku": "UT-1717-GRE-M"
            },
            {
                "id": 2891,
                "color": "WHITE",
                "size": "L",
                "sku": "UT-1717-WHE-L"
            },
            {
                "id": 2883,
                "color": "IVORY",
                "size": "XL",
                "sku": "UT-1717-IVY-XL"
            },
            {
                "id": 2905,
                "color": "LIGHT GREEN",
                "size": "2XL",
                "sku": "UT-1717-LIN-2XL"
            },
            {
                "id": 2884,
                "color": "IVORY",
                "size": "2XL",
                "sku": "UT-1717-IVY-2XL"
            },
            {
                "id": 2918,
                "color": "YAM",
                "size": "L",
                "sku": "UT-1717-YAM-L"
            },
            {
                "id": 2902,
                "color": "LIGHT GREEN",
                "size": "M",
                "sku": "UT-1717-LIN-M"
            },
            {
                "id": 2887,
                "color": "ORCHID",
                "size": "L",
                "sku": "UT-1717-ORD-L"
            },
            {
                "id": 2916,
                "color": "YAM",
                "size": "S",
                "sku": "UT-1717-YAM-S"
            },
            {
                "id": 2885,
                "color": "IVORY",
                "size": "3XL",
                "sku": "UT-1717-IVY-3XL"
            },
            {
                "id": 2647,
                "color": "ORCHID",
                "size": "S",
                "sku": "UT-1717-ORD-S"
            },
            {
                "id": 2894,
                "color": "MOSS",
                "size": "S",
                "sku": "UT-1717-MOS-S"
            },
            {
                "id": 2879,
                "color": "PEPPER",
                "size": "3XL",
                "sku": "UT-1717-PER-3XL"
            },
            {
                "id": 2898,
                "color": "MOSS",
                "size": "2XL",
                "sku": "UT-1717-MOS-2XL"
            },
            {
                "id": 2872,
                "color": "BLACK",
                "size": "2XL",
                "sku": "UT-1717-BLK-2XL"
            },
            {
                "id": 2871,
                "color": "BLACK",
                "size": "XL",
                "sku": "UT-1717-BLK-XL"
            },
            {
                "id": 2869,
                "color": "BLACK",
                "size": "M",
                "sku": "UT-1717-BLK-M"
            },
            {
                "id": 2874,
                "color": "PEPPER",
                "size": "S",
                "sku": "UT-1717-PER-S"
            },
            {
                "id": 2878,
                "color": "PEPPER",
                "size": "2XL",
                "sku": "UT-1717-PER-2XL"
            },
            {
                "id": 2875,
                "color": "PEPPER",
                "size": "M",
                "sku": "UT-1717-PER-M"
            },
            {
                "id": 2870,
                "color": "BLACK",
                "size": "L",
                "sku": "UT-1717-BLK-L"
            },
            {
                "id": 2876,
                "color": "PEPPER",
                "size": "L",
                "sku": "UT-1717-PER-L"
            },
            {
                "id": 2877,
                "color": "PEPPER",
                "size": "XL",
                "sku": "UT-1717-PER-XL"
            }
        ],
        "name": "Unisex-ComfortColor-UnisexT-Shirt",
        "sku": "1717"
    },
    {
        "variations": [
            {
                "id": 2627,
                "color": "WHITE",
                "size": "S",
                "sku": "UT-3001-WHE-S"
            },
            {
                "id": 2951,
                "color": "DARK GREY HEATHER",
                "size": "2XL",
                "sku": "UT-3001-DAR-2XL"
            },
            {
                "id": 2964,
                "color": "ATHLETIC HEATHER",
                "size": "L",
                "sku": "UT-3001-ATR-L"
            },
            {
                "id": 2941,
                "color": "WHITE",
                "size": "XL",
                "sku": "UT-3001-WHE-XL"
            },
            {
                "id": 2969,
                "color": "NAVY",
                "size": "2XL",
                "sku": "UT-3001-NAY-2XL"
            },
            {
                "id": 2940,
                "color": "NAVY",
                "size": "XL",
                "sku": "UT-3001-NAY-XL"
            },
            {
                "id": 2934,
                "color": "NAVY",
                "size": "M",
                "sku": "UT-3001-NAY-M"
            },
            {
                "id": 2956,
                "color": "HEATHER MAUVE",
                "size": "L",
                "sku": "UT-3001-HEE-L"
            },
            {
                "id": 2952,
                "color": "HEATHER NAVY",
                "size": "L",
                "sku": "UT-3001-HEY-L"
            },
            {
                "id": 2946,
                "color": "NATURAL",
                "size": "L",
                "sku": "UT-3001-NAL-L"
            },
            {
                "id": 2947,
                "color": "NATURAL",
                "size": "XL",
                "sku": "UT-3001-NAL-XL"
            },
            {
                "id": 2945,
                "color": "NATURAL",
                "size": "M",
                "sku": "UT-3001-NAL-M"
            },
            {
                "id": 2938,
                "color": "WHITE",
                "size": "L",
                "sku": "UT-3001-WHE-L"
            },
            {
                "id": 2965,
                "color": "ATHLETIC HEATHER",
                "size": "XL",
                "sku": "UT-3001-ATR-XL"
            },
            {
                "id": 2950,
                "color": "DARK GREY HEATHER",
                "size": "XL",
                "sku": "UT-3001-DAR-XL"
            },
            {
                "id": 2628,
                "color": "NATURAL",
                "size": "S",
                "sku": "UT-3001-NAL-S"
            },
            {
                "id": 2948,
                "color": "NATURAL",
                "size": "2XL",
                "sku": "UT-3001-NAL-2XL"
            },
            {
                "id": 2955,
                "color": "HEATHER MAUVE",
                "size": "M",
                "sku": "UT-3001-HEE-M"
            },
            {
                "id": 2928,
                "color": "BLACK",
                "size": "S",
                "sku": "UT-3001-BLK-S"
            },
            {
                "id": 3008,
                "color": "DARK GREY HEATHER",
                "size": "M",
                "sku": "UT-3001-DAR-M"
            },
            {
                "id": 2967,
                "color": "BLACK",
                "size": "2XL",
                "sku": "UT-3001-BLK-2XL"
            },
            {
                "id": 2937,
                "color": "NAVY",
                "size": "L",
                "sku": "UT-3001-NAY-L"
            },
            {
                "id": 2962,
                "color": "HEATHER MAUVE",
                "size": "2XL",
                "sku": "UT-3001-HEE-2XL"
            },
            {
                "id": 2957,
                "color": "ATHLETIC HEATHER",
                "size": "S",
                "sku": "UT-3001-ATR-S"
            },
            {
                "id": 2935,
                "color": "WHITE",
                "size": "M",
                "sku": "UT-3001-WHE-M"
            },
            {
                "id": 2943,
                "color": "HEATHER NAVY",
                "size": "S",
                "sku": "UT-3001-HEY-S"
            },
            {
                "id": 2939,
                "color": "BLACK",
                "size": "XL",
                "sku": "UT-3001-BLK-XL"
            },
            {
                "id": 2953,
                "color": "HEATHER NAVY",
                "size": "XL",
                "sku": "UT-3001-HEY-XL"
            },
            {
                "id": 2949,
                "color": "DARK GREY HEATHER",
                "size": "L",
                "sku": "UT-3001-DAR-L"
            },
            {
                "id": 3036,
                "color": "Heather Navy",
                "size": "M",
                "sku": "UT-3001-HEY-M"
            },
            {
                "id": 2966,
                "color": "ATHLETIC HEATHER",
                "size": "2XL",
                "sku": "UT-3001-ATR-2XL"
            },
            {
                "id": 2929,
                "color": "NAVY",
                "size": "S",
                "sku": "UT-3001-NAY-S"
            },
            {
                "id": 2933,
                "color": "BLACK",
                "size": "M",
                "sku": "UT-3001-BLK-M"
            },
            {
                "id": 2968,
                "color": "WHITE",
                "size": "2XL",
                "sku": "UT-3001-WHE-2XL"
            },
            {
                "id": 2963,
                "color": "ATHLETIC HEATHER",
                "size": "M",
                "sku": "UT-3001-ATR-M"
            },
            {
                "id": 2942,
                "color": "DARK GREY HEATHER",
                "size": "S",
                "sku": "UT-3001-DAR-S"
            },
            {
                "id": 2961,
                "color": "HEATHER MAUVE",
                "size": "XL",
                "sku": "UT-3001-HEE-XL"
            },
            {
                "id": 2944,
                "color": "HEATHER MAUVE",
                "size": "S",
                "sku": "UT-3001-HEE-S"
            },
            {
                "id": 2936,
                "color": "BLACK",
                "size": "L",
                "sku": "UT-3001-BLK-L"
            },
            {
                "id": 2954,
                "color": "HEATHER NAVY",
                "size": "2XL",
                "sku": "UT-3001-HEY-2XL"
            }
        ],
        "name": "Unisex-BellaCanvas-UnisexT-Shirt",
        "sku": "3001"
    },
    {
        "variations": [
            {
                "id": 2736,
                "color": "FOREST GREEN",
                "size": "L",
                "sku": "UT-5000-FON-L"
            },
            {
                "id": 2721,
                "color": "SAND",
                "size": "XL",
                "sku": "UT-5000-SAD-XL"
            },
            {
                "id": 2666,
                "color": "LIGHT BLUE",
                "size": "M",
                "sku": "UT-5000-LIE-M"
            },
            {
                "id": 2679,
                "color": "PURPLE",
                "size": "M",
                "sku": "UT-5000-PUE-M"
            },
            {
                "id": 2777,
                "color": "ORANGE",
                "size": "XL",
                "sku": "UT-5000-ORE-XL"
            },
            {
                "id": 2763,
                "color": "DAISY",
                "size": "L",
                "sku": "UT-5000-DAY-L"
            },
            {
                "id": 2775,
                "color": "ORANGE",
                "size": "M",
                "sku": "UT-5000-ORE-M"
            },
            {
                "id": 2711,
                "color": "ASH",
                "size": "XL",
                "sku": "UT-5000-ASH-XL"
            },
            {
                "id": 2705,
                "color": "DARK HEATHER",
                "size": "XL",
                "sku": "UT-5000-DAR-XL"
            },
            {
                "id": 2704,
                "color": "DARK HEATHER",
                "size": "L",
                "sku": "UT-5000-DAR-L"
            },
            {
                "id": 2703,
                "color": "DARK HEATHER",
                "size": "M",
                "sku": "UT-5000-DAR-M"
            },
            {
                "id": 2691,
                "color": "WHITE",
                "size": "M",
                "sku": "UT-5000-WHE-M"
            },
            {
                "id": 2750,
                "color": "ROYAL",
                "size": "XL",
                "sku": "UT-5000-ROL-XL"
            },
            {
                "id": 2698,
                "color": "SPORT GREY",
                "size": "L",
                "sku": "UT-5000-SPY-L"
            },
            {
                "id": 2694,
                "color": "WHITE",
                "size": "2XL",
                "sku": "UT-5000-WHE-2XL"
            },
            {
                "id": 2695,
                "color": "WHITE",
                "size": "3XL",
                "sku": "UT-5000-WHE-3XL"
            },
            {
                "id": 2678,
                "color": "NAVY",
                "size": "3XL",
                "sku": "UT-5000-NAY-3XL"
            },
            {
                "id": 2656,
                "color": "MILITARY GREEN",
                "size": "XL",
                "sku": "UT-5000-MIN-XL"
            },
            {
                "id": 2670,
                "color": "LIGHT BLUE",
                "size": "3XL",
                "sku": "UT-5000-LIE-3XL"
            },
            {
                "id": 2690,
                "color": "WHITE",
                "size": "S",
                "sku": "UT-5000-WHE-S"
            },
            {
                "id": 2707,
                "color": "DARK HEATHER",
                "size": "3XL",
                "sku": "UT-5000-DAR-3XL"
            },
            {
                "id": 2723,
                "color": "SAND",
                "size": "3XL",
                "sku": "UT-5000-SAD-3XL"
            },
            {
                "id": 2677,
                "color": "NAVY",
                "size": "2XL",
                "sku": "UT-5000-NAY-2XL"
            },
            {
                "id": 2700,
                "color": "SPORT GREY",
                "size": "2XL",
                "sku": "UT-5000-SPY-2XL"
            },
            {
                "id": 2675,
                "color": "NAVY",
                "size": "L",
                "sku": "UT-5000-NAY-L"
            },
            {
                "id": 2701,
                "color": "SPORT GREY",
                "size": "3XL",
                "sku": "UT-5000-SPY-3XL"
            },
            {
                "id": 2653,
                "color": "MILITARY GREEN",
                "size": "M",
                "sku": "UT-5000-MIN-M"
            },
            {
                "id": 2658,
                "color": "MILITARY GREEN",
                "size": "2XL",
                "sku": "UT-5000-MIN-2XL"
            },
            {
                "id": 2716,
                "color": "MAROON",
                "size": "2XL",
                "sku": "UT-5000-MAN-2XL"
            },
            {
                "id": 2683,
                "color": "PURPLE",
                "size": "3XL",
                "sku": "UT-5000-PUE-3XL"
            },
            {
                "id": 2765,
                "color": "DAISY",
                "size": "2XL",
                "sku": "UT-5000-DAY-2XL"
            },
            {
                "id": 2654,
                "color": "MILITARY GREEN",
                "size": "L",
                "sku": "UT-5000-MIN-L"
            },
            {
                "id": 2696,
                "color": "SPORT GREY",
                "size": "S",
                "sku": "UT-5000-SPY-S"
            },
            {
                "id": 2748,
                "color": "ROYAL",
                "size": "M",
                "sku": "UT-5000-ROL-M"
            },
            {
                "id": 2753,
                "color": "BLACK",
                "size": "5XL",
                "sku": "UT-5000-BLK-5XL"
            },
            {
                "id": 2680,
                "color": "PURPLE",
                "size": "L",
                "sku": "UT-5000-PUE-L"
            },
            {
                "id": 2685,
                "color": "RED",
                "size": "M",
                "sku": "UT-5000-RED-M"
            },
            {
                "id": 2738,
                "color": "DARK CHOCOLATE",
                "size": "XL",
                "sku": "UT-5000-DAE-XL"
            },
            {
                "id": 2688,
                "color": "RED",
                "size": "2XL",
                "sku": "UT-5000-RED-2XL"
            },
            {
                "id": 2676,
                "color": "NAVY",
                "size": "XL",
                "sku": "UT-5000-NAY-XL"
            },
            {
                "id": 2682,
                "color": "PURPLE",
                "size": "2XL",
                "sku": "UT-5000-PUE-2XL"
            },
            {
                "id": 2674,
                "color": "NAVY",
                "size": "M",
                "sku": "UT-5000-NAY-M"
            },
            {
                "id": 2712,
                "color": "MAROON",
                "size": "S",
                "sku": "UT-5000-MAN-S"
            },
            {
                "id": 2651,
                "color": "PURPLE",
                "size": "S",
                "sku": "UT-5000-PUE-S"
            },
            {
                "id": 2751,
                "color": "ROYAL",
                "size": "2XL",
                "sku": "UT-5000-ROL-2XL"
            },
            {
                "id": 2702,
                "color": "DARK HEATHER",
                "size": "S",
                "sku": "UT-5000-DAR-S"
            },
            {
                "id": 2756,
                "color": "TENNESSEE ORANGE",
                "size": "M",
                "sku": "UT-5000-TEE-M"
            },
            {
                "id": 3042,
                "color": "LIGHT PINK",
                "size": "3XL",
                "sku": "UT-5000-LIK-3XL"
            },
            {
                "id": 2755,
                "color": "TENNESSEE ORANGE",
                "size": "S",
                "sku": "UT-5000-TEE-S"
            },
            {
                "id": 2710,
                "color": "ASH",
                "size": "L",
                "sku": "UT-5000-ASH-L"
            },
            {
                "id": 2684,
                "color": "RED",
                "size": "S",
                "sku": "UT-5000-RED-S"
            },
            {
                "id": 2780,
                "color": "DARK CHOCOLATE",
                "size": "3XL",
                "sku": "UT-5000-DAE-3XL"
            },
            {
                "id": 2687,
                "color": "RED",
                "size": "XL",
                "sku": "UT-5000-RED-XL"
            },
            {
                "id": 2671,
                "color": "MILITARY GREEN",
                "size": "S",
                "sku": "UT-5000-MIN-S"
            },
            {
                "id": 2782,
                "color": "ORANGE",
                "size": "3XL",
                "sku": "UT-5000-ORE-3XL"
            },
            {
                "id": 2747,
                "color": "ROYAL",
                "size": "S",
                "sku": "UT-5000-ROL-S"
            },
            {
                "id": 2672,
                "color": "MILITARY GREEN",
                "size": "3XL",
                "sku": "UT-5000-MIN-3XL"
            },
            {
                "id": 2771,
                "color": "HELICONIA",
                "size": "2XL",
                "sku": "UT-5000-HEA-2XL"
            },
            {
                "id": 2732,
                "color": "DARK CHOCOLATE",
                "size": "S",
                "sku": "UT-5000-DAE-S"
            },
            {
                "id": 2776,
                "color": "ORANGE",
                "size": "L",
                "sku": "UT-5000-ORE-L"
            },
            {
                "id": 2719,
                "color": "SAND",
                "size": "M",
                "sku": "UT-5000-SAD-M"
            },
            {
                "id": 2760,
                "color": "TENNESSEE ORANGE",
                "size": "3XL",
                "sku": "UT-5000-TEE-3XL"
            },
            {
                "id": 2734,
                "color": "NATURAL",
                "size": "S",
                "sku": "UT-5000-NAL-S"
            },
            {
                "id": 2714,
                "color": "MAROON",
                "size": "L",
                "sku": "UT-5000-MAN-L"
            },
            {
                "id": 2652,
                "color": "ASH",
                "size": "2XL",
                "sku": "UT-5000-ASH-2XL"
            },
            {
                "id": 2754,
                "color": "WHITE",
                "size": "5XL",
                "sku": "UT-5000-WHE-5XL"
            },
            {
                "id": 2733,
                "color": "FOREST GREEN",
                "size": "S",
                "sku": "UT-5000-FON-S"
            },
            {
                "id": 2769,
                "color": "HELICONIA",
                "size": "L",
                "sku": "UT-5000-HEA-L"
            },
            {
                "id": 2766,
                "color": "DAISY",
                "size": "3XL",
                "sku": "UT-5000-DAY-3XL"
            },
            {
                "id": 2669,
                "color": "LIGHT BLUE",
                "size": "2XL",
                "sku": "UT-5000-LIE-2XL"
            },
            {
                "id": 2752,
                "color": "ROYAL",
                "size": "3XL",
                "sku": "UT-5000-ROL-3XL"
            },
            {
                "id": 3040,
                "color": "LIGHT PINK",
                "size": "XL",
                "sku": "UT-5000-LIK-XL"
            },
            {
                "id": 2768,
                "color": "HELICONIA",
                "size": "M",
                "sku": "UT-5000-HEA-M"
            },
            {
                "id": 2722,
                "color": "SAND",
                "size": "2XL",
                "sku": "UT-5000-SAD-2XL"
            },
            {
                "id": 2726,
                "color": "WHITE",
                "size": "4XL",
                "sku": "UT-5000-WHE-4XL"
            },
            {
                "id": 2730,
                "color": "DARK CHOCOLATE",
                "size": "M",
                "sku": "UT-5000-DAE-M"
            },
            {
                "id": 2724,
                "color": "ASH",
                "size": "3XL",
                "sku": "UT-5000-ASH-3XL"
            },
            {
                "id": 3037,
                "color": "LIGHT PINK",
                "size": "S",
                "sku": "UT-5000-LIK-S"
            },
            {
                "id": 3041,
                "color": "LIGHT PINK",
                "size": "2XL",
                "sku": "UT-5000-LIK-2XL"
            },
            {
                "id": 3038,
                "color": "LIGHT PINK",
                "size": "M",
                "sku": "UT-5000-LIK-M"
            },
            {
                "id": 2697,
                "color": "SPORT GREY",
                "size": "M",
                "sku": "UT-5000-SPY-M"
            },
            {
                "id": 2772,
                "color": "HELICONIA",
                "size": "3XL",
                "sku": "UT-5000-HEA-3XL"
            },
            {
                "id": 2709,
                "color": "ASH",
                "size": "M",
                "sku": "UT-5000-ASH-M"
            },
            {
                "id": 2735,
                "color": "DARK CHOCOLATE",
                "size": "L",
                "sku": "UT-5000-DAE-L"
            },
            {
                "id": 2665,
                "color": "LIGHT BLUE",
                "size": "S",
                "sku": "UT-5000-LIE-S"
            },
            {
                "id": 2668,
                "color": "LIGHT BLUE",
                "size": "XL",
                "sku": "UT-5000-LIE-XL"
            },
            {
                "id": 2761,
                "color": "DAISY",
                "size": "S",
                "sku": "UT-5000-DAY-S"
            },
            {
                "id": 2767,
                "color": "HELICONIA",
                "size": "S",
                "sku": "UT-5000-HEA-S"
            },
            {
                "id": 2737,
                "color": "NATURAL",
                "size": "L",
                "sku": "UT-5000-NAL-L"
            },
            {
                "id": 2740,
                "color": "NATURAL",
                "size": "XL",
                "sku": "UT-5000-NAL-XL"
            },
            {
                "id": 2739,
                "color": "FOREST GREEN",
                "size": "XL",
                "sku": "UT-5000-FON-XL"
            },
            {
                "id": 2774,
                "color": "NATURAL",
                "size": "M",
                "sku": "UT-5000-NAL-M"
            },
            {
                "id": 2681,
                "color": "PURPLE",
                "size": "XL",
                "sku": "UT-5000-PUE-XL"
            },
            {
                "id": 2758,
                "color": "TENNESSEE ORANGE",
                "size": "XL",
                "sku": "UT-5000-TEE-XL"
            },
            {
                "id": 2779,
                "color": "ORANGE",
                "size": "2XL",
                "sku": "UT-5000-ORE-2XL"
            },
            {
                "id": 2667,
                "color": "LIGHT BLUE",
                "size": "L",
                "sku": "UT-5000-LIE-L"
            },
            {
                "id": 2713,
                "color": "MAROON",
                "size": "M",
                "sku": "UT-5000-MAN-M"
            },
            {
                "id": 2720,
                "color": "SAND",
                "size": "L",
                "sku": "UT-5000-SAD-L"
            },
            {
                "id": 2778,
                "color": "NATURAL",
                "size": "2XL",
                "sku": "UT-5000-NAL-2XL"
            },
            {
                "id": 2757,
                "color": "TENNESSEE ORANGE",
                "size": "L",
                "sku": "UT-5000-TEE-L"
            },
            {
                "id": 2728,
                "color": "FOREST GREEN",
                "size": "2XL",
                "sku": "UT-5000-FON-2XL"
            },
            {
                "id": 2689,
                "color": "RED",
                "size": "3XL",
                "sku": "UT-5000-RED-3XL"
            },
            {
                "id": 2717,
                "color": "MAROON",
                "size": "3XL",
                "sku": "UT-5000-MAN-3XL"
            },
            {
                "id": 2727,
                "color": "DARK CHOCOLATE",
                "size": "2XL",
                "sku": "UT-5000-DAE-2XL"
            },
            {
                "id": 2718,
                "color": "SAND",
                "size": "S",
                "sku": "UT-5000-SAD-S"
            },
            {
                "id": 2762,
                "color": "DAISY",
                "size": "M",
                "sku": "UT-5000-DAY-M"
            },
            {
                "id": 2773,
                "color": "ORANGE",
                "size": "S",
                "sku": "UT-5000-ORE-S"
            },
            {
                "id": 2764,
                "color": "DAISY",
                "size": "XL",
                "sku": "UT-5000-DAY-XL"
            },
            {
                "id": 2729,
                "color": "FOREST GREEN",
                "size": "3XL",
                "sku": "UT-5000-FON-3XL"
            },
            {
                "id": 2673,
                "color": "NAVY",
                "size": "S",
                "sku": "UT-5000-NAY-S"
            },
            {
                "id": 2759,
                "color": "TENNESSEE ORANGE",
                "size": "2XL",
                "sku": "UT-5000-TEE-2XL"
            },
            {
                "id": 2770,
                "color": "HELICONIA",
                "size": "XL",
                "sku": "UT-5000-HEA-XL"
            },
            {
                "id": 2749,
                "color": "ROYAL",
                "size": "L",
                "sku": "UT-5000-ROL-L"
            },
            {
                "id": 2715,
                "color": "MAROON",
                "size": "XL",
                "sku": "UT-5000-MAN-XL"
            },
            {
                "id": 2708,
                "color": "ASH",
                "size": "S",
                "sku": "UT-5000-ASH-S"
            },
            {
                "id": 3039,
                "color": "LIGHT PINK",
                "size": "L",
                "sku": "UT-5000-LIK-L"
            },
            {
                "id": 2725,
                "color": "BLACK",
                "size": "4XL",
                "sku": "UT-5000-BLK-4XL"
            },
            {
                "id": 2692,
                "color": "WHITE",
                "size": "L",
                "sku": "UT-5000-WHE-L"
            },
            {
                "id": 2699,
                "color": "SPORT GREY",
                "size": "XL",
                "sku": "UT-5000-SPY-XL"
            },
            {
                "id": 2741,
                "color": "CHARCOAL",
                "size": "S",
                "sku": "UT-5000-CHL-S"
            },
            {
                "id": 2693,
                "color": "WHITE",
                "size": "XL",
                "sku": "UT-5000-WHE-XL"
            },
            {
                "id": 2662,
                "color": "BLACK",
                "size": "XL",
                "sku": "UT-5000-BLK-XL"
            },
            {
                "id": 2781,
                "color": "NATURAL",
                "size": "3XL",
                "sku": "UT-5000-NAL-3XL"
            },
            {
                "id": 2706,
                "color": "DARK HEATHER",
                "size": "2XL",
                "sku": "UT-5000-DAR-2XL"
            },
            {
                "id": 2746,
                "color": "CHARCOAL",
                "size": "3XL",
                "sku": "UT-5000-CHL-3XL"
            },
            {
                "id": 2661,
                "color": "BLACK",
                "size": "L",
                "sku": "UT-5000-BLK-L"
            },
            {
                "id": 2745,
                "color": "CHARCOAL",
                "size": "2XL",
                "sku": "UT-5000-CHL-2XL"
            },
            {
                "id": 2731,
                "color": "FOREST GREEN",
                "size": "M",
                "sku": "UT-5000-FON-M"
            },
            {
                "id": 2686,
                "color": "RED",
                "size": "L",
                "sku": "UT-5000-RED-L"
            },
            {
                "id": 2664,
                "color": "BLACK",
                "size": "3XL",
                "sku": "UT-5000-BLK-3XL"
            },
            {
                "id": 2663,
                "color": "BLACK",
                "size": "2XL",
                "sku": "UT-5000-BLK-2XL"
            },
            {
                "id": 2659,
                "color": "BLACK",
                "size": "S",
                "sku": "UT-5000-BLK-S"
            },
            {
                "id": 2742,
                "color": "CHARCOAL",
                "size": "M",
                "sku": "UT-5000-CHL-M"
            },
            {
                "id": 2743,
                "color": "CHARCOAL",
                "size": "L",
                "sku": "UT-5000-CHL-L"
            },
            {
                "id": 2660,
                "color": "BLACK",
                "size": "M",
                "sku": "UT-5000-BLK-M"
            },
            {
                "id": 2744,
                "color": "CHARCOAL",
                "size": "XL",
                "sku": "UT-5000-CHL-XL"
            }
        ],
        "name": "Unisex-Gildan-UnisexT-Shirt",
        "sku": "5000"
    },
    {
        "variations": [
            {
                "id": 2824,
                "color": "ORANGE",
                "size": "M",
                "sku": "SW-18000-ORE-M"
            },
            {
                "id": 2832,
                "color": "FOREST GREEN",
                "size": "2XL",
                "sku": "SW-18000-FON-2XL"
            },
            {
                "id": 2830,
                "color": "FOREST GREEN",
                "size": "L",
                "sku": "SW-18000-FON-L"
            },
            {
                "id": 3032,
                "color": "RED",
                "size": "M",
                "sku": "SW-18000-RED-M"
            },
            {
                "id": 3011,
                "color": "SAND",
                "size": "3XL",
                "sku": "SW-18000-SAD-3XL"
            },
            {
                "id": 2797,
                "color": "DARK HEATHER",
                "size": "2XL",
                "sku": "SW-18000-DAR-2XL"
            },
            {
                "id": 2837,
                "color": "CHARCOAL",
                "size": "2XL",
                "sku": "SW-18000-CHL-2XL"
            },
            {
                "id": 2801,
                "color": "NAVY",
                "size": "XL",
                "sku": "SW-18000-NAY-XL"
            },
            {
                "id": 2817,
                "color": "SAND",
                "size": "M",
                "sku": "SW-18000-SAD-M"
            },
            {
                "id": 2816,
                "color": "SAND",
                "size": "S",
                "sku": "SW-18000-SAD-S"
            },
            {
                "id": 2812,
                "color": "MAROON",
                "size": "2XL",
                "sku": "SW-18000-MAN-2XL"
            },
            {
                "id": 2806,
                "color": "WHITE",
                "size": "XL",
                "sku": "SW-18000-WHE-XL"
            },
            {
                "id": 2820,
                "color": "SAND",
                "size": "2XL",
                "sku": "SW-18000-SAD-2XL"
            },
            {
                "id": 2825,
                "color": "ORANGE",
                "size": "L",
                "sku": "SW-18000-ORE-L"
            },
            {
                "id": 3033,
                "color": "RED",
                "size": "L",
                "sku": "SW-18000-RED-L"
            },
            {
                "id": 2840,
                "color": "LIGHT BLUE",
                "size": "L",
                "sku": "SW-18000-LIE-L"
            },
            {
                "id": 3020,
                "color": "LIGHT BLUE",
                "size": "3XL",
                "sku": "SW-18000-LIE-3XL"
            },
            {
                "id": 2831,
                "color": "FOREST GREEN",
                "size": "XL",
                "sku": "SW-18000-FON-XL"
            },
            {
                "id": 3017,
                "color": "NAVY",
                "size": "3XL",
                "sku": "SW-18000-NAY-3XL"
            },
            {
                "id": 2810,
                "color": "MAROON",
                "size": "L",
                "sku": "SW-18000-MAN-L"
            },
            {
                "id": 3034,
                "color": "RED",
                "size": "XL",
                "sku": "SW-18000-RED-XL"
            },
            {
                "id": 3012,
                "color": "SPORT GREY",
                "size": "3XL",
                "sku": "SW-18000-SPY-3XL"
            },
            {
                "id": 2815,
                "color": "MILITARY GREEN",
                "size": "XL",
                "sku": "SW-18000-MIN-XL"
            },
            {
                "id": 2809,
                "color": "MAROON",
                "size": "M",
                "sku": "SW-18000-MAN-M"
            },
            {
                "id": 2835,
                "color": "CHARCOAL",
                "size": "L",
                "sku": "SW-18000-CHL-L"
            },
            {
                "id": 2787,
                "color": "SPORT GREY",
                "size": "2XL",
                "sku": "SW-18000-SPY-2XL"
            },
            {
                "id": 2783,
                "color": "SPORT GREY",
                "size": "S",
                "sku": "SW-18000-SPY-S"
            },
            {
                "id": 2795,
                "color": "DARK HEATHER",
                "size": "L",
                "sku": "SW-18000-DAR-L"
            },
            {
                "id": 3016,
                "color": "DARK HEATHER",
                "size": "3XL",
                "sku": "SW-18000-DAR-3XL"
            },
            {
                "id": 2822,
                "color": "MILITARY GREEN",
                "size": "2XL",
                "sku": "SW-18000-MIN-2XL"
            },
            {
                "id": 2789,
                "color": "BLACK",
                "size": "M",
                "sku": "SW-18000-BLK-M"
            },
            {
                "id": 2784,
                "color": "SPORT GREY",
                "size": "M",
                "sku": "SW-18000-SPY-M"
            },
            {
                "id": 3013,
                "color": "ORANGE",
                "size": "3XL",
                "sku": "SW-18000-ORE-3XL"
            },
            {
                "id": 2836,
                "color": "CHARCOAL",
                "size": "XL",
                "sku": "SW-18000-CHL-XL"
            },
            {
                "id": 2785,
                "color": "SPORT GREY",
                "size": "L",
                "sku": "SW-18000-SPY-L"
            },
            {
                "id": 2821,
                "color": "MILITARY GREEN",
                "size": "L",
                "sku": "SW-18000-MIN-L"
            },
            {
                "id": 2811,
                "color": "MAROON",
                "size": "XL",
                "sku": "SW-18000-MAN-XL"
            },
            {
                "id": 2827,
                "color": "ORANGE",
                "size": "2XL",
                "sku": "SW-18000-ORE-2XL"
            },
            {
                "id": 2834,
                "color": "CHARCOAL",
                "size": "M",
                "sku": "SW-18000-CHL-M"
            },
            {
                "id": 2841,
                "color": "LIGHT BLUE",
                "size": "XL",
                "sku": "SW-18000-LIE-XL"
            },
            {
                "id": 2805,
                "color": "WHITE",
                "size": "L",
                "sku": "SW-18000-WHE-L"
            },
            {
                "id": 2814,
                "color": "MILITARY GREEN",
                "size": "M",
                "sku": "SW-18000-MIN-M"
            },
            {
                "id": 2800,
                "color": "NAVY",
                "size": "L",
                "sku": "SW-18000-NAY-L"
            },
            {
                "id": 3035,
                "color": "RED",
                "size": "2XL",
                "sku": "SW-18000-RED-2XL"
            },
            {
                "id": 2786,
                "color": "SPORT GREY",
                "size": "XL",
                "sku": "SW-18000-SPY-XL"
            },
            {
                "id": 2803,
                "color": "WHITE",
                "size": "S",
                "sku": "SW-18000-WHE-S"
            },
            {
                "id": 2788,
                "color": "BLACK",
                "size": "S",
                "sku": "SW-18000-BLK-S"
            },
            {
                "id": 3015,
                "color": "FOREST GREEN",
                "size": "3XL",
                "sku": "SW-18000-FON-3XL"
            },
            {
                "id": 3018,
                "color": "MAROON",
                "size": "3XL",
                "sku": "SW-18000-MAN-3XL"
            },
            {
                "id": 2838,
                "color": "LIGHT BLUE",
                "size": "S",
                "sku": "SW-18000-LIE-S"
            },
            {
                "id": 2818,
                "color": "SAND",
                "size": "L",
                "sku": "SW-18000-SAD-L"
            },
            {
                "id": 3014,
                "color": "MILITARY GREEN",
                "size": "3XL",
                "sku": "SW-18000-MIN-3XL"
            },
            {
                "id": 2807,
                "color": "WHITE",
                "size": "2XL",
                "sku": "SW-18000-WHE-2XL"
            },
            {
                "id": 2802,
                "color": "NAVY",
                "size": "2XL",
                "sku": "SW-18000-NAY-2XL"
            },
            {
                "id": 3009,
                "color": "BLACK",
                "size": "3XL",
                "sku": "SW-18000-BLK-3XL"
            },
            {
                "id": 2794,
                "color": "DARK HEATHER",
                "size": "M",
                "sku": "SW-18000-DAR-M"
            },
            {
                "id": 2829,
                "color": "FOREST GREEN",
                "size": "M",
                "sku": "SW-18000-FON-M"
            },
            {
                "id": 2791,
                "color": "BLACK",
                "size": "XL",
                "sku": "SW-18000-BLK-XL"
            },
            {
                "id": 2804,
                "color": "WHITE",
                "size": "M",
                "sku": "SW-18000-WHE-M"
            },
            {
                "id": 2813,
                "color": "MILITARY GREEN",
                "size": "S",
                "sku": "SW-18000-MIN-S"
            },
            {
                "id": 2796,
                "color": "DARK HEATHER",
                "size": "XL",
                "sku": "SW-18000-DAR-XL"
            },
            {
                "id": 2793,
                "color": "DARK HEATHER",
                "size": "S",
                "sku": "SW-18000-DAR-S"
            },
            {
                "id": 2828,
                "color": "FOREST GREEN",
                "size": "S",
                "sku": "SW-18000-FON-S"
            },
            {
                "id": 2799,
                "color": "NAVY",
                "size": "M",
                "sku": "SW-18000-NAY-M"
            },
            {
                "id": 2790,
                "color": "BLACK",
                "size": "L",
                "sku": "SW-18000-BLK-L"
            },
            {
                "id": 3019,
                "color": "CHARCOAL",
                "size": "3XL",
                "sku": "SW-18000-CHL-3XL"
            },
            {
                "id": 3010,
                "color": "WHITE",
                "size": "3XL",
                "sku": "SW-18000-WHE-3XL"
            },
            {
                "id": 2808,
                "color": "MAROON",
                "size": "S",
                "sku": "SW-18000-MAN-S"
            },
            {
                "id": 2823,
                "color": "ORANGE",
                "size": "S",
                "sku": "SW-18000-ORE-S"
            },
            {
                "id": 2798,
                "color": "NAVY",
                "size": "S",
                "sku": "SW-18000-NAY-S"
            },
            {
                "id": 2839,
                "color": "LIGHT BLUE",
                "size": "M",
                "sku": "SW-18000-LIE-M"
            },
            {
                "id": 2833,
                "color": "CHARCOAL",
                "size": "S",
                "sku": "SW-18000-CHL-S"
            },
            {
                "id": 2842,
                "color": "LIGHT BLUE",
                "size": "2XL",
                "sku": "SW-18000-LIE-2XL"
            },
            {
                "id": 2819,
                "color": "SAND",
                "size": "XL",
                "sku": "SW-18000-SAD-XL"
            },
            {
                "id": 2826,
                "color": "ORANGE",
                "size": "XL",
                "sku": "SW-18000-ORE-XL"
            },
            {
                "id": 2792,
                "color": "BLACK",
                "size": "2XL",
                "sku": "SW-18000-BLK-2XL"
            }
        ],
        "name": "Unisex-Gildan-Sweatshirt",
        "sku": "18000"
    },
    {
        "variations": [
            {
                "id": 2865,
                "color": "Sand",
                "size": "L",
                "sku": "HG-18500-SAD-L"
            },
            {
                "id": 2854,
                "color": "DARK HEATHER",
                "size": "M",
                "sku": "HG-18500-DAR-M"
            },
            {
                "id": 3030,
                "color": "NAVY",
                "size": "2XL",
                "sku": "HG-18500-NAY-2XL"
            },
            {
                "id": 2866,
                "color": "Sand",
                "size": "XL",
                "sku": "HG-18500-SAD-XL"
            },
            {
                "id": 2844,
                "color": "SPORT GREY",
                "size": "M",
                "sku": "HG-18500-SPY-M"
            },
            {
                "id": 2853,
                "color": "DARK HEATHER",
                "size": "S",
                "sku": "HG-18500-DAR-S"
            },
            {
                "id": 3022,
                "color": "WHITE",
                "size": "3XL",
                "sku": "HG-18500-WHE-3XL"
            },
            {
                "id": 2845,
                "color": "SPORT GREY",
                "size": "L",
                "sku": "HG-18500-SPY-L"
            },
            {
                "id": 2851,
                "color": "Black",
                "size": "XL",
                "sku": "HG-18500-BLK-XL"
            },
            {
                "id": 2860,
                "color": "White",
                "size": "L",
                "sku": "HG-18500-WHE-L"
            },
            {
                "id": 2864,
                "color": "Sand",
                "size": "M",
                "sku": "HG-18500-SAD-M"
            },
            {
                "id": 3025,
                "color": "SPORT GREY",
                "size": "3XL",
                "sku": "HG-18500-SPY-3XL"
            },
            {
                "id": 2863,
                "color": "Sand",
                "size": "S",
                "sku": "HG-18500-SAD-S"
            },
            {
                "id": 2848,
                "color": "Black",
                "size": "S",
                "sku": "HG-18500-BLK-S"
            },
            {
                "id": 3023,
                "color": "SAND",
                "size": "3XL",
                "sku": "HG-18500-SAD-3XL"
            },
            {
                "id": 3026,
                "color": "NAVY",
                "size": "S",
                "sku": "HG-18500-NAY-S"
            },
            {
                "id": 3028,
                "color": "NAVY",
                "size": "L",
                "sku": "HG-18500-NAY-L"
            },
            {
                "id": 2847,
                "color": "SPORT GREY",
                "size": "2XL",
                "sku": "HG-18500-SPY-2XL"
            },
            {
                "id": 3031,
                "color": "NAVY",
                "size": "3XL",
                "sku": "HG-18500-NAY-3XL"
            },
            {
                "id": 3021,
                "color": "BLACK",
                "size": "3XL",
                "sku": "HG-18500-BLK-3XL"
            },
            {
                "id": 2867,
                "color": "Sand",
                "size": "2XL",
                "sku": "HG-18500-SAD-2XL"
            },
            {
                "id": 2859,
                "color": "White",
                "size": "M",
                "sku": "HG-18500-WHE-M"
            },
            {
                "id": 2850,
                "color": "Black",
                "size": "L",
                "sku": "HG-18500-BLK-L"
            },
            {
                "id": 2861,
                "color": "White",
                "size": "XL",
                "sku": "HG-18500-WHE-XL"
            },
            {
                "id": 3029,
                "color": "NAVY",
                "size": "XL",
                "sku": "HG-18500-NAY-XL"
            },
            {
                "id": 2862,
                "color": "White",
                "size": "2XL",
                "sku": "HG-18500-WHE-2XL"
            },
            {
                "id": 2846,
                "color": "SPORT GREY",
                "size": "XL",
                "sku": "HG-18500-SPY-XL"
            },
            {
                "id": 2858,
                "color": "White",
                "size": "S",
                "sku": "HG-18500-WHE-S"
            },
            {
                "id": 3024,
                "color": "DARK HEATHER",
                "size": "3XL",
                "sku": "HG-18500-DAR-3XL"
            },
            {
                "id": 2856,
                "color": "DARK HEATHER",
                "size": "XL",
                "sku": "HG-18500-DAR-XL"
            },
            {
                "id": 2857,
                "color": "DARK HEATHER",
                "size": "2XL",
                "sku": "HG-18500-DAR-2XL"
            },
            {
                "id": 2855,
                "color": "DARK HEATHER",
                "size": "L",
                "sku": "HG-18500-DAR-L"
            },
            {
                "id": 2843,
                "color": "SPORT GREY",
                "size": "S",
                "sku": "HG-18500-SPY-S"
            },
            {
                "id": 2852,
                "color": "Black",
                "size": "2XL",
                "sku": "HG-18500-BLK-2XL"
            },
            {
                "id": 2849,
                "color": "Black",
                "size": "M",
                "sku": "HG-18500-BLK-M"
            },
            {
                "id": 3027,
                "color": "NAVY",
                "size": "M",
                "sku": "HG-18500-NAY-M"
            }
        ],
        "name": "Unisex-Gildan-Hoodie",
        "sku": "18500"
    },
    {
        "variations": [
            {
                "id": 2960,
                "color": "WHITE",
                "size": "S",
                "sku": "YT-5000B-WHE-S"
            },
            {
                "id": 2633,
                "color": "DARK HEATHER",
                "size": "M",
                "sku": "YT-5000B-DAR-M"
            },
            {
                "id": 2972,
                "color": "SAND",
                "size": "S",
                "sku": "YT-5000B-SAD-S"
            },
            {
                "id": 2959,
                "color": "BLACK",
                "size": "M",
                "sku": "YT-5000B-BLK-M"
            },
            {
                "id": 2984,
                "color": "DARK HEATHER",
                "size": "L",
                "sku": "YT-5000B-DAR-L"
            },
            {
                "id": 2631,
                "color": "SPORT GREY",
                "size": "M",
                "sku": "YT-5000B-SPY-M"
            },
            {
                "id": 2974,
                "color": "RED",
                "size": "S",
                "sku": "YT-5000B-RED-S"
            },
            {
                "id": 2958,
                "color": "BLACK",
                "size": "S",
                "sku": "YT-5000B-BLK-S"
            },
            {
                "id": 2981,
                "color": "RED",
                "size": "XL",
                "sku": "YT-5000B-RED-XL"
            },
            {
                "id": 2975,
                "color": "RED",
                "size": "M",
                "sku": "YT-5000B-RED-M"
            },
            {
                "id": 2973,
                "color": "SAND",
                "size": "M",
                "sku": "YT-5000B-SAD-M"
            },
            {
                "id": 2976,
                "color": "WHITE",
                "size": "L",
                "sku": "YT-5000B-WHE-L"
            },
            {
                "id": 2970,
                "color": "BLACK",
                "size": "L",
                "sku": "YT-5000B-BLK-L"
            },
            {
                "id": 2979,
                "color": "SAND",
                "size": "XL",
                "sku": "YT-5000B-SAD-XL"
            },
            {
                "id": 2630,
                "color": "SPORT GREY",
                "size": "S",
                "sku": "YT-5000B-SPY-S"
            },
            {
                "id": 2629,
                "color": "WHITE",
                "size": "M",
                "sku": "YT-5000B-WHE-M"
            },
            {
                "id": 2632,
                "color": "DARK HEATHER",
                "size": "S",
                "sku": "YT-5000B-DAR-S"
            },
            {
                "id": 2982,
                "color": "SPORT GREY",
                "size": "L",
                "sku": "YT-5000B-SPY-L"
            },
            {
                "id": 2978,
                "color": "SAND",
                "size": "L",
                "sku": "YT-5000B-SAD-L"
            },
            {
                "id": 2971,
                "color": "BLACK",
                "size": "XL",
                "sku": "YT-5000B-BLK-XL"
            },
            {
                "id": 2985,
                "color": "DARK HEATHER",
                "size": "XL",
                "sku": "YT-5000B-DAR-XL"
            },
            {
                "id": 2977,
                "color": "WHITE",
                "size": "XL",
                "sku": "YT-5000B-WHE-XL"
            },
            {
                "id": 2980,
                "color": "RED",
                "size": "L",
                "sku": "YT-5000B-RED-L"
            },
            {
                "id": 2983,
                "color": "SPORT GREY",
                "size": "XL",
                "sku": "YT-5000B-SPY-XL"
            }
        ],
        "name": "Youth-Gildan-YouthT-Shirt",
        "sku": "5000B"
    },
    {
        "variations": [
            {
                "id": 2990,
                "color": "WHITE",
                "size": "S",
                "sku": "YT-3001Y-WHE-S"
            },
            {
                "id": 2636,
                "color": "NATURAL",
                "size": "S",
                "sku": "YT-3001Y-NAL-S"
            },
            {
                "id": 2993,
                "color": "DARK GREY",
                "size": "M",
                "sku": "YT-3001Y-DAY-M"
            },
            {
                "id": 2988,
                "color": "BLACK",
                "size": "L",
                "sku": "YT-3001Y-BLK-L"
            },
            {
                "id": 2657,
                "color": "DARK GREY",
                "size": "XL",
                "sku": "YT-3001Y-DAY-XL"
            },
            {
                "id": 2986,
                "color": "BLACK",
                "size": "S",
                "sku": "YT-3001Y-BLK-S"
            },
            {
                "id": 2644,
                "color": "PINK",
                "size": "M",
                "sku": "YT-3001Y-PIK-M"
            },
            {
                "id": 2992,
                "color": "DARK GREY",
                "size": "S",
                "sku": "YT-3001Y-DAY-S"
            },
            {
                "id": 2637,
                "color": "NATURAL",
                "size": "M",
                "sku": "YT-3001Y-NAL-M"
            },
            {
                "id": 2643,
                "color": "TRUE ROYAL",
                "size": "XL",
                "sku": "YT-3001Y-TRL-XL"
            },
            {
                "id": 2635,
                "color": "WHITE",
                "size": "XL",
                "sku": "YT-3001Y-WHE-XL"
            },
            {
                "id": 2634,
                "color": "WHITE",
                "size": "L",
                "sku": "YT-3001Y-WHE-L"
            },
            {
                "id": 2994,
                "color": "PINK",
                "size": "S",
                "sku": "YT-3001Y-PIK-S"
            },
            {
                "id": 2641,
                "color": "TRUE ROYAL",
                "size": "M",
                "sku": "YT-3001Y-TRL-M"
            },
            {
                "id": 2987,
                "color": "BLACK",
                "size": "M",
                "sku": "YT-3001Y-BLK-M"
            },
            {
                "id": 2640,
                "color": "TRUE ROYAL",
                "size": "S",
                "sku": "YT-3001Y-TRL-S"
            },
            {
                "id": 2642,
                "color": "TRUE ROYAL",
                "size": "L",
                "sku": "YT-3001Y-TRL-L"
            },
            {
                "id": 2645,
                "color": "PINK",
                "size": "L",
                "sku": "YT-3001Y-PIK-L"
            },
            {
                "id": 2655,
                "color": "DARK GREY",
                "size": "L",
                "sku": "YT-3001Y-DAY-L"
            },
            {
                "id": 2639,
                "color": "NATURAL",
                "size": "XL",
                "sku": "YT-3001Y-NAL-XL"
            },
            {
                "id": 2989,
                "color": "BLACK",
                "size": "XL",
                "sku": "YT-3001Y-BLK-XL"
            },
            {
                "id": 2646,
                "color": "PINK",
                "size": "XL",
                "sku": "YT-3001Y-PIK-XL"
            },
            {
                "id": 2991,
                "color": "WHITE",
                "size": "M",
                "sku": "YT-3001Y-WHE-M"
            },
            {
                "id": 2638,
                "color": "NATURAL",
                "size": "L",
                "sku": "YT-3001Y-NAL-L"
            }
        ],
        "name": "Youth-BellaCanvas-YouthT-Shirt",
        "sku": "3001Y"
    },
    {
        "variations": [
            {
                "id": 2995,
                "color": "BLACK",
                "size": "S",
                "sku": "WT-5000L-BLK-S"
            },
            {
                "id": 3003,
                "color": "WHITE",
                "size": "L",
                "sku": "WT-5000L-WHE-L"
            },
            {
                "id": 3000,
                "color": "BLACK",
                "size": "3XL",
                "sku": "WT-5000L-BLK-3XL"
            },
            {
                "id": 2997,
                "color": "BLACK",
                "size": "L",
                "sku": "WT-5000L-BLK-L"
            },
            {
                "id": 3006,
                "color": "WHITE",
                "size": "3XL",
                "sku": "WT-5000L-WHE-3XL"
            },
            {
                "id": 3002,
                "color": "WHITE",
                "size": "M",
                "sku": "WT-5000L-WHE-M"
            },
            {
                "id": 2996,
                "color": "BLACK",
                "size": "M",
                "sku": "WT-5000L-BLK-M"
            },
            {
                "id": 3005,
                "color": "WHITE",
                "size": "2XL",
                "sku": "WT-5000L-WHE-2XL"
            },
            {
                "id": 3001,
                "color": "WHITE",
                "size": "S",
                "sku": "WT-5000L-WHE-S"
            },
            {
                "id": 2998,
                "color": "BLACK",
                "size": "XL",
                "sku": "WT-5000L-BLK-XL"
            },
            {
                "id": 2999,
                "color": "BLACK",
                "size": "2XL",
                "sku": "WT-5000L-BLK-2XL"
            },
            {
                "id": 3004,
                "color": "WHITE",
                "size": "XL",
                "sku": "WT-5000L-WHE-XL"
            }
        ],
        "name": "Women-Gildan-WomenT-Shirt",
        "sku": "5000L"
    }
]
export default apbeeful